app.service('deliveryPointModal', function (modal, deliveryPointAutocomplete, deliveryPointLocation, orderConfig, loading, geolocation, console, broker) {
	let locations = [];
	let images = {};
	let gMarkers = [];
	let visibleMarkers = [];
	let selectedTypes = [];
	let $self, $type, $selectAll;
	let map, markerClusterer, autocompleteInput, selectedPointCallback;
	let initiated = false;
	let config;
	let selectedPoint;
	let imgPath = "/img/rwd/google-maps/";

	const markerClustererStyle = [
		{
			width: 53,
			height: 53,
			url: imgPath + "m1.png",
			textColor: "#ffffff",
			textSize: 10,
		},
		{
			width: 56,
			height: 56,
			url: imgPath + "m2.png",
			textColor: "#ffffff",
			textSize: 11,
		},
		{
			width: 66,
			height: 66,
			url: imgPath + "m3.png",
			textColor: "#ffffff",
			textSize: 12,
		},
		{
			width: 78,
			height: 78,
			url: imgPath + "m4.png",
			textColor: "#ffffff",
			textSize: 12,
		},
		{
			width: 90,
			height: 90,
			url: imgPath + "m5.png",
			textColor: "#ffffff",
			textSize: 12,
		},
	];

	function fetchPoints() {
		const locker = '/web-cached/collection-parcel-machines.ltr';
		const pickupPoints = '/web-cached/collection-pickup-points.ltr';
		return $.ajax({
			url: (config.deliveryType == 'inpost' ? locker : pickupPoints)
		});
	}

	function fetchSelectedPoint(id) {
		const locker = '/web-cached/parcel-machine-details.ltr?code=' + id;
		const pickupPoints = '/web-cached/pickup-point-details.ltr?code=' + id;
		return $.ajax({
			url: (config.deliveryType == 'inpost' ? locker : pickupPoints)
		});
	}

	function mapStart(params) {
		const mapOptions = {
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			mapTypeControl: false,
			streetViewControl: false,
			minZoom: 6,
			clickableIcons: false,
			fullscreenControl: false
		};
		let myLatLng;
		let zoom;
		if (params.lat && params.lng) {
			zoom = 13;
			myLatLng = new google.maps.LatLng(params.lat, params.lng);
		} else {
			zoom = 6;
			myLatLng = new google.maps.LatLng(51.803754, 19.5707663);		// polska cała
		}
		map = new google.maps.Map(document.getElementById("map"), mapOptions);
		showPlaceOnMap(myLatLng, zoom);
		markerClusterer = new MarkerClusterer(map, visibleMarkers, {
			imagePath: imgPath + "m",
			styles: markerClustererStyle
		});
	}

	function addMarkersToMap() {
		if (map) {
			markerClusterer.clearMarkers();
			markerClusterer.addMarkers(visibleMarkers);
		}
	}

	function showMarkers(brands) {
		visibleMarkers = [];
		gMarkers.forEach(function (marker) {
			if (brands.length === 0 || $.inArray(marker.brand, brands) > -1) {
				visibleMarkers.push(marker);
			}
		})
		addMarkersToMap();
	}

	function populateMarkers() {
		gMarkers = [];
		let visibleTypes = [];
		locations.forEach((element, i) => {
			if(element[5] && config.deliveryType !== 'inpost' && config.availablePickupPointKinds.indexOf(element[5]) === -1){
				return;
			}
			var brand = (config.deliveryType == 'inpost' ? 'INPOST' : element[3]);
			visibleTypes.push(brand);
			var img = `${imgPath}${config.deliveryType == 'inpost' ? 'inpost' : element[3]}.png`;
			if (config.deliveryType != 'inpost' && images[element[3]]) {
				img = images[element[3]];
			}
			else if (config.deliveryType == 'inpost' && images['inpost']) {
				img = images['inpost'];
			}
			const factory = new google.maps.Marker({
				brand: brand,
				position: { lat: parseFloat(element[2]), lng: parseFloat(element[1]) },
				icon: img
			});
			gMarkers.push(factory);
			google.maps.event.addListener(factory, "click", function () {
				const clickedMarker = this;
				console.log('Pobranie danych punktu z mapy: '+element[0]+' ['+element[3]+']');
				fetchSelectedPoint(element[0]).then(function (html) {
					selectedPoint = {
						id: element[0],
						html: html,
						lat: parseFloat(element[2]),
						lng: parseFloat(element[1])
					}
					$('#selected-delivery-point').html(html);
					map.panTo(clickedMarker.getPosition());
					map.panBy(0, 50);
					$('#selected-point').removeClass('hidden');
				}).fail(onFetchSelectedPointError);
			});
		});
		visibleTypes = [...new Set(visibleTypes)];
		//console.log(visibleTypes)
		$type.not($selectAll).each(function(){
			let $this = $(this);
			if(!visibleTypes.includes($this.data('type'))){
				$this.remove();
			}
		});
	}

	function setLocations(data) {
		locations = data.locations;
		images = data.images;
	}

	function setElements() {
		$self = $('#modal-delivery-points');
		$type = $('.js-parcel-type', $self);
		$selectAll = $('.js-parcel-type[data-type=0]', $self);
		autocompleteInput = $('.place-search', $self)[0];
	}

	function setSelectedParcelType(value) {
		if (value == '0') {
			selectedTypes = [];
		} else {
			const idx = $.inArray(value, selectedTypes);
			if (idx == -1) {
				selectedTypes.push(value);
			} else {
				selectedTypes.splice(idx, 1);
			}
		}
	}
	function hidePreview() {
		$('#selected-point').addClass('hidden');
	}

	function setEvents() {
		$self.on('click', '.js-selected-point-close', function () {
			hidePreview();
		}).on('click', '.js-delivery-points-search', function () {
			$self.addClass('search-geolocation');
			var $this = $(this);
			geolocation.findPosition(function (position) {
				$self.removeClass('search-geolocation');
				$this.attr({
					latitude: position.latitude,
					longitude: position.longitude
				});
				showPlaceOnMap({
					lat: position.latitude,
					lng: position.longitude,
				});
			}, function (error) {
				$self.removeClass('search-geolocation');
			});
		}).on('click', '.js-parcel-type', function () {
			const parcelName = $(this).data('type');
			setSelectedParcelType(parcelName);
			$type.removeClass('selected');
			if (!selectedTypes.length) {
				$selectAll.addClass('selected');
			} else {
				selectedTypes.forEach(function (t) {
					$type.filter('[data-type="' + t + '"]').addClass('selected');
				});
			}
			showMarkers(selectedTypes);
		}).on('click', '.js-choose-point', function () {
			hidePreview();
			selectedPointCallback(selectedPoint);
			modal.close();
		}).on('click', '.js-toggle-openings-hours', function (event) {
			$(this).closest('.js-delivery-point').toggleClass('show-opening-hours');
			event.preventDefault();
			event.stopPropagation();
		}).on('click','.js-search-button', function() {
			if(autocompleteInput.value != '') {
				deliveryPointLocation.findPlaceByAddress(autocompleteInput.value, function (location, partialMatch) {
					if (location && !partialMatch) {
						showPlaceOnMap(location);
					} else {
						showEmptyResults();
					}
				});
			}
		});

		deliveryPointAutocomplete.setAutocomplete(autocompleteInput, function (location) {
			if (location) {
				showPlaceOnMap(location);
			}
		}, function () {
			showEmptyResults();
		});
	}
	function showEmptyResults() {
		$self.addClass('empty-location');
		$('.empty-location-message strong', $self).text($.trim(autocompleteInput.value));
	}
	function showPlaceOnMap(latLng, zoom = 13) {
		$self.removeClass('empty-location');
		map.setCenter(latLng);
		map.setZoom(zoom);
	}
	broker.on('BEFORE_PAGE_CHANGE', function() {
		initiated = false;
	});

	function open(params, callback) {
		var modalOptions = {
			modifier: 'remodal-full-height'
		}
		if (!initiated) {
			config = orderConfig.getData();
			loading.start();
			fetchPoints().then(function (data) {		// przykład: [	[ "typ", "id", longitude, latitude ], [ "SHOP_ZABKA", "DHL POP ŻABKA", 21.0390077, 52.26276 ]]
				loading.stop();
				setElements();
				setEvents();
				setLocations(data);
				populateMarkers();
				autocompleteInput.value = params.input;
				modal.open('delivery-points', modalOptions);
				mapStart(params);
				showMarkers(selectedTypes);
				initiated = true;
			}).fail(onFetchPointsError);
		} else {
			autocompleteInput.value = params.input;
			modal.open('delivery-points', modalOptions);
			showPlaceOnMap(params);
		}
		selectedPointCallback = callback;
	}

	function onFetchPointsError(e) {
		console.log(e);
		loading.stop();
		modal.alert("Błąd pobierania punktów odbioru. Spróbuj ponownie za chwilę.");
	}

	function onFetchSelectedPointError(e) {
		console.log(e);
		modal.alert("Błąd pobierania wybranego punktu odbioru. Spróbuj ponownie za chwilę.");
	}

	return {
		open
	};
});